<template>
  <div>
    <div>
      <div class="text-xs-right">
        <v-btn @click="$emit('close')" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div class="pa-4">
        <v-layout row wrap>
          <v-flex xs6>
            <div class="form-control pr-1">
              <label>Name</label>
              <input v-model="input.name" type="text" />
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="form-control pl-1">
              <label>Brand</label>
              <multiselect
                v-model="input.brand"
                :options="brandOptions"
                selectLabel
                selectedLabel
                :searchable="false"
                deselect-label
                open-direction="bottom"
              ></multiselect>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="form-control pl-1">
              <label>Membership type</label>
              <multiselect
                v-model="input.membertype"
                :options="typeOptions"
                selectLabel
                selectedLabel
                :searchable="false"
                deselect-label
                open-direction="bottom"
              ></multiselect>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="form-control pl-1">
              <label>Status</label>
              <multiselect
                v-model="input.status"
                :options="statusOptions"
                selectLabel
                selectedLabel
                :searchable="false"
                deselect-label
                open-direction="bottom"
              ></multiselect>
            </div>
          </v-flex>

          <v-flex xs12>
            <div class="form-control">
              <v-layout row wrap>
                <v-flex xs6 class="pr-1">
                  <label>Register Date - From</label>
                  <DatePickerWithoutButton v-model="input.registerdate_from">
                    <input
                      readonly
                      :value="input.registerdate_from"
                      placeholder="วันที่"
                      type="text"
                    />
                  </DatePickerWithoutButton>
                </v-flex>
                <v-flex xs6 class="pl-1">
                  <label>Register Date - To</label>
                  <DatePickerWithoutButton v-model="input.registerdate_to">
                    <input
                      readonly
                      :value="input.registerdate_to"
                      placeholder="วันที่"
                      type="text"
                    /> </DatePickerWithoutButton
                ></v-flex>
              </v-layout></div
          ></v-flex>
          <v-flex xs12>
            <div class="form-control">
              <v-layout row wrap>
                <v-flex xs6 class="pr-1">
                  <label>Expired Date - From</label>

                  <DatePickerWithoutButton v-model="input.expireddate_from">
                    <input
                      readonly
                      :value="input.expireddate_from"
                      placeholder="วันที่"
                      type="text"
                    />
                  </DatePickerWithoutButton>
                </v-flex>
                <v-flex xs6 class="pl-1">
                  <label>Expired Date - To</label>

                  <DatePickerWithoutButton v-model="input.expireddate_to">
                    <input
                      readonly
                      :value="input.expireddate_to"
                      placeholder="วันที่"
                      type="text"
                    /> </DatePickerWithoutButton
                ></v-flex>
              </v-layout></div
          ></v-flex>
          <v-flex xs12>
            <label for>{{ $t('Tag') }}</label>
            <multiselect
              :options="tagOptions"
              v-model="input.tags"
              :placeholder="$t('Tags')"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
            >
            </multiselect>
          </v-flex>
        </v-layout>
        <div>
          <v-btn @click="onsearch" depressed block color="primary">{{ $t('Search') }}</v-btn>
          <v-btn @click="clearsearch" block flat color="grey">{{ $t('Clear search') }}</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import Multiselect from 'vue-multiselect'
import Tags from '@/components/elements/Tags'
export default {
  components: {
    DatePickerWithoutButton,
    Multiselect,
    Tags
  },
  data() {
    return {
      typeOptions: ['sharemembership', 'basicmembership'],
      brandOptions: ['GRAM Pancakes', 'PABLO Cheese Tart', 'KOF'],
      statusOptions: ['Expired', 'Active'],
      input: {
        name: '',
        membertype: '',
        registerdate_from: '',
        registerdate_to: '',
        expireddate_from: '',
        expireddate_to: '',
        brand: '',
        status: '',
        tags: ''
      },
      tagOptions: []
    }
  },

  methods: {
    clearsearch() {
      this.input = {
        name: '',
        membertype: '',
        registerdate_from: '',
        registerdate_to: '',
        expireddate_from: '',
        expireddate_to: '',
        brand: '',
        status: '',
        tags: []
      }
      this.$emit('onsearch', this.input)
    },
    onsearch() {
      if (this.input.tags) {
        var tags = this.input.tags
        this.input.tags = tags.join()
      }

      this.$emit('onsearch', this.input)
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 9999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTag(newTag) {
      const tag = newTag
      this.tagOptions.push(tag)
      this.input.tags.push(tag)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/grampablokof/MemberFilter.vue